import React from 'react';
import {
    Box,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Checkbox,
    ListItemText,
    FormControlLabel,
    Switch,
    Chip,
    OutlinedInput,
    SelectChangeEvent,
} from '@mui/material';
import { useFafsaData } from '../contexts';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

export const FafsaFilterControls = () => {
    const { filter, updateFilter } = useFafsaData();

    //school year options (last 5 years including current)
    const currentYear = new Date().getFullYear();
    const schoolYearOptions = Array.from({ length: 5 }, (_, i) => currentYear - i);

    const handleYearChange = (event: SelectChangeEvent<number[]>) => {
        const value = event.target.value;
        updateFilter({
            schoolYears: typeof value === 'string' ? value.split(',').map(Number) : value,
        });
    };

    const handleGroupByChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        updateFilter({ groupBySchool: event.target.checked });
    };

    return (
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap', mb: 2 }}>
            <FormControl sx={{ minWidth: 200 }}>
                <InputLabel id="school-year-label">School Year</InputLabel>
                <Select
                    labelId="school-year-label"
                    multiple
                    value={filter.schoolYears}
                    onChange={handleYearChange}
                    input={<OutlinedInput label="School Year" />}
                    renderValue={(selected) => (
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                            {selected.map((value) => (
                                <Chip key={value} label={value} size="small" />
                            ))}
                        </Box>
                    )}
                    MenuProps={MenuProps}
                >
                    {schoolYearOptions.map((year) => (
                        <MenuItem key={year} value={year}>
                            <Checkbox checked={filter.schoolYears.indexOf(year) > -1} />
                            <ListItemText primary={`${year}-${year + 1}`} />
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            <FormControlLabel
                control={
                    <Switch
                        checked={filter.groupBySchool}
                        onChange={handleGroupByChange}
                        color="primary"
                    />
                }
                label="Group by School"
            />
        </Box>
    );
};